import PropTypes from "prop-types"
import React, { createContext, useState } from "react"
import { Outlet, useMatch, useNavigate } from "react-router-dom"

import Tabs from "src/components/Tabs"

export const AccountingContext = createContext(null)

const TABS = ["setup", "manage", "mapping", "export"]
const V2_TABS = ["setup", "item_mapping", "revenue_mapping", "sync"]

const AccountingView = ({
  marinaSlug,
  integration: accountingIntegration,
  accountingBases,
  accountingService,
  connectionGuideUrl,
  accountingV2Enabled,
  userHasAdminRole,
  categoryOptions,
}) => {
  const [integration, setIntegration] = useState(accountingIntegration)
  const navigate = useNavigate()
  const [selectedAccountingService, setSelectedAccountingService] =
    useState(accountingService)
  const tabSet = accountingV2Enabled ? V2_TABS : TABS

  const currentTabName = useMatch("/:tabName")?.params?.tabName
  const currentTabIndex = tabSet.includes(currentTabName)
    ? tabSet.indexOf(currentTabName)
    : 0

  return (
    <AccountingContext.Provider
      value={{
        accountingBases,
        connectionGuideUrl,
        integration,
        setIntegration,
        marinaSlug,
        selectedAccountingService,
        setSelectedAccountingService,
        accountingV2Enabled,
        userHasAdminRole,
        categoryOptions,
      }}
    >
      <div className="-mt-4 w-full bg-gray-100" id="accounting-index">
        <Tabs
          selectedIndex={currentTabIndex}
          onChange={(tabIndex) => navigate(`/${tabSet[tabIndex]}`)}
        >
          <div className="flex w-full flex-col justify-between bg-white lg:flex-row">
            <div className="order-2 mt-4 flex justify-center border-b px-6 lg:order-1 lg:border-none">
              <Tabs.TabList>
                <Tabs.Tab title="Setup" />
                <Tabs.Tab
                  title={accountingV2Enabled ? "Item Mapping" : "Manage"}
                />
                <Tabs.Tab
                  title={accountingV2Enabled ? "Revenue Mapping" : "Mapping"}
                />
                <Tabs.Tab
                  title={accountingV2Enabled ? "Sync Details" : "Export"}
                />
              </Tabs.TabList>
            </div>
          </div>
          <div className="px-8">
            <Tabs.Panels>
              {tabSet.map((tabName) => (
                <Tabs.Panel key={tabName}>
                  <Outlet />
                </Tabs.Panel>
              ))}
            </Tabs.Panels>
          </div>
        </Tabs>
      </div>
    </AccountingContext.Provider>
  )
}

AccountingView.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.number.isRequired,
    setupComplete: PropTypes.bool.isRequired,
    accountingBasis: PropTypes.string,
    serviceId: PropTypes.string.isRequired,
    dynamicConfiguration: PropTypes.object.isRequired,
    preparing: PropTypes.bool.isRequired,
    status: PropTypes.oneOf(["active", "inactive"]).isRequired,
  }),
  marinaSlug: PropTypes.string.isRequired,
  accountingService: PropTypes.shape({
    name: PropTypes.string.isRequired,
    serviceId: PropTypes.string.isRequired,
  }),
  accountingBases: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
  connectionGuideUrl: PropTypes.string.isRequired,
  accountingV2Enabled: PropTypes.bool.isRequired,
  userHasAdminRole: PropTypes.bool.isRequired,
  categoryOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
}

export default AccountingView
